
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[slug]",
      function () {
        return require("private-next-pages/projects/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[slug]"])
      });
    }
  